(function () {
  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest(".js-morecolor-open");
    if (!openBtn) return;

    var list = openBtn.closest(".js-morecolor-list");
    if (!list) return;

    list.classList.add("is-open");
  });
})();
